import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import { all } from 'redux-saga/effects';
import { authSagas } from 'src/state/auth/authSagas';
import { createRootReducer, RootState } from 'src/state/reducer';
import {
  createReducerInjector,
  createSagaInjector,
} from 'src/lib/reduxInjectors';
import { companyConfirmationSagas } from 'src/state/companyConfirmation/companyConfirmationSagas';
import { businessPartnerSaga } from 'src/state/businessPartner/businessPartnerSagas';

function* rootSaga() {
  yield all([authSagas(), companyConfirmationSagas(), businessPartnerSaga()]);
}

const rootStateFactory = () => {
  const sagaMiddleware = createSagaMiddleware();
  const { injectSaga, deleteSaga } = createSagaInjector(sagaMiddleware.run);
  const isProduction = process.env.GATSBY_APP_ENVIRONMENT_NAME === 'production';
  const devTools =
    !isProduction &&
    typeof window !== 'undefined' &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  const composeEnhancers = devTools || compose;
  const enhancer = composeEnhancers(applyMiddleware(sagaMiddleware));

  const rootReducer = createRootReducer();

  const store = createStore(combineReducers<RootState>(rootReducer), enhancer);
  const persistor = persistStore(store);
  const { injectReducer, deleteReducer } = createReducerInjector(
    rootReducer,
    store.replaceReducer
  );
  injectSaga('root', rootSaga);

  return {
    store,
    persistor,
    injectReducer,
    deleteReducer,
    injectSaga,
    deleteSaga,
  };
};

export const {
  store,
  persistor,
  injectReducer,
  deleteReducer,
  injectSaga,
  deleteSaga,
} = rootStateFactory();
